export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-cf1819950446c7563cdb09966c0db01d.svg";